import { Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'src/models/general/select.item.model';

@Pipe({
    name: 'selectItemText',
    standalone: false
})
export class SelectItemTextPipe implements PipeTransform {

	transform(selectItemId: string, selectItems: SelectItem[] | null): string {
		if (!selectItemId) {
			throw Error(`Missing parameters - ID: ${selectItemId}, Items: ${selectItems}`);
		}
		const item = selectItems?.find((entry: SelectItem) => {
			return entry.id === selectItemId;
		});

		return item ? item.value : selectItemId;
	}

}
